import { Project, ProjectsApiResponse, projectsApiResponseSchema, projectSchema, LogApiResponse, logApiResponseSchema } from '@repo/shared/domain';
import { guardedClient as clientRequest, constructQuery } from '@repo/shared/helpers';

export const getProjects = async (query?: string): Promise<ProjectsApiResponse> => {
	const { body } = await clientRequest.get(`/api/projects${query ? `?${query}` : ''}`, {
		schema: projectsApiResponseSchema,
	});
	return body;
};

export const getProject = async (projectId: string): Promise<Project | undefined> => {
	try {
		const { body } = await clientRequest.get(`/api/projects/${projectId}`, {
			schema: projectSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get project:', error);
		return undefined;
	}
};

export const getProjectLogs = async (
	projectId: string,
	params?: { from?: string; until?: string; page?: number; sort?: string },
): Promise<LogApiResponse> => {
	const query = constructQuery({
		from: params?.from,
		until: params?.until,
		page: params?.page,
		sort: params?.sort || 'timestamp:desc',
	});
	const { body } = await clientRequest.get(`/api/projects/${projectId}/logs?${query}`, {
		schema: logApiResponseSchema,
	});
	return body;
};
